import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-android-development',
  templateUrl: './android-development.component.html',
  styleUrls: ['./android-development.component.scss']
})
export class AndroidDevelopmentComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Android Development - Xipe Tech';
  contentDescription = 'XipeTech offers cutting-edge Android development services, delivering high-performance mobile apps that enhance user experience and solve complex business challenges with innovative technology.';
  contentKeywords = 'android development, android app development, mobile app development, android software solutions, custom android applications, android programming, android application design, android app services, android mobile solutions, android development company';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
